import { styled } from '@lingoda/ui/theme';
import { Menu as UiMenu } from '@lingoda/ui';

export const Menu = styled(UiMenu)(({ theme }) => ({
    '& .MuiList-padding': {
        padding: `${theme.spacing(2)} 0`,
    },
}));
